export default "__VITE_ASSET__rAztvHRG__"